module.exports = __webpack_public_path__ + "static/media/Template_6.f63c9f17.png";